// Loads the date picker bundle (JS + CSS) the first time a date field needs it.
let loading = null;

function addScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}

function addStyles(href) {
    if (document.querySelector(`link[href="${href}"]`)) return;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
}

export function loadDatePicker(js, css) {
    if (window.hibasDatePicker) return Promise.resolve();
    if (!loading) {
        addStyles(css);
        loading = addScript(js);
    }
    return loading;
}

// yyyy-mm-dd (as sent by Formie) -> dd.mm.yyyy; anything else is returned as it is
export function toNorwegianDate(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || "");
    return match ? `${match[3]}.${match[2]}.${match[1]}` : value || "";
}
